import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { useInlineNotifications } from '../../../../hooks'
import { FormikForm } from '../../../Formik'
import { FormModalContainer } from '../../FormModalContainer'
import { FormModalBody } from '../FormModalBody'

import { FORM_MODAL_CONTENT_CONTAINER_BOX_SIZE } from './FormModalContent.constants'

function FormModalContent({
  Fields,
  FormBody = FormModalBody,
  containerProps,
  formBodyProps,
  formFieldsProps,
  formTitle,
  getSaveConfirmCondition,
  initialNotifications,
  initialValues,
  saveConfirm,
  saveConfirmationProps: {
    onSubmit: onSubmitSaveConfirmation,
    ...saveConfirmationProps
  } = EMPTY_OBJECT,
  validationSchema,
  onClose,
  onSubmit,
}) {
  const [isCloseConfirm, setCloseConfirm] = useState(false)
  const [isSaveConfirm, setSaveConfirm] = useState(false)

  const { t } = useTranslation()

  const { handleAddNotification, handleRemoveNotification, notifications } =
    useInlineNotifications({ initialNotifications })

  function handleClose(params) {
    if (params?.dirty) {
      setCloseConfirm(true)

      return
    }

    onClose()
  }

  function handleSubmit(values, formikHelpers) {
    if (saveConfirm && getSaveConfirmCondition(values)) {
      setCloseConfirm(true)
      setSaveConfirm(true)

      formikHelpers.setSubmitting(false)

      return
    }

    onSubmit(values, formikHelpers)
  }

  function handleSubmitConfirm(values) {
    if (isSaveConfirm) {
      const submitHandler = onSubmitSaveConfirmation || onSubmit

      submitHandler(values)

      return
    }

    onClose()
  }

  function handleCloseConfirm() {
    setCloseConfirm(false)

    setSaveConfirm(false)
  }

  return (
    <FormikForm
      enableReinitialize
      Container={FormModalContainer}
      containerProps={{
        ...containerProps,
        boxSize:
          containerProps?.boxSize || FORM_MODAL_CONTENT_CONTAINER_BOX_SIZE,
        confirmationProps: {
          ...containerProps?.confirmationProps,
          ...(isSaveConfirm ? saveConfirmationProps : null),
        },
        isCloseConfirm,
        setCloseConfirm,
        title: t(formTitle),
        onClose,
        onCloseConfirm: handleCloseConfirm,
        onSubmitConfirm: handleSubmitConfirm,
      }}
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <FormBody
        {...formBodyProps}
        Fields={Fields}
        formFieldsProps={formFieldsProps}
        notifications={notifications}
        validationErrorsNotificationProps={{
          ...formBodyProps?.validationErrorsNotificationProps,
          onRemoveNotification: handleRemoveNotification,
          onSetNotification: handleAddNotification,
        }}
        onCancel={handleClose}
      />
    </FormikForm>
  )
}

export default FormModalContent
